import { render, staticRenderFns } from "./ProjectJoin.vue?vue&type=template&id=4ef6d3d8"
import script from "./ProjectJoin.vue?vue&type=script&lang=js"
export * from "./ProjectJoin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports